<template>
  <div>
    <div class="m-2 text-center">
      <b-spinner />
      <div class="mt-1">
        <small v-text="$t('common.loading')" />
      </div>
    </div>
  </div>
</template>
<script>

import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'Loading',
  components: { BSpinner },
}
</script>
